<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="600px" :destroy-on-close="true"
      :before-close="cancel">
      <div>
        <el-form label-width="125px" ref="form" :model="form" :rules="rules">
          <el-form-item label="合同负责人:" prop="contractPrincipalUuid">
            <el-select v-model="form.contractPrincipalUuid" filterable placeholder="请选择合同负责人" style="width: 400px;">
              <el-option v-for="item in personOption" :key="item.id" :label="item.name" :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票负责人:" prop="invoicedPrincipalUuid">
            <el-select v-model="form.invoicedPrincipalUuid" filterable placeholder="请选择发票负责人" style="width: 400px;">
              <el-option v-for="item in personOption" :key="item.id" :label="item.name" :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {bindCharge} from "@/api/dilivery/company";
import {getPersonByType} from "@/api/dilivery/customer/person";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "CompanyBindCharge",
  props:['showDialog','selectDetail'],
  components: { Loading },
  data(){
    return{
      title: '绑定负责人',
      loading:false,
      personOption:[],
      form: {
        id:[],
        contractPrincipalUuid: '',
        invoicedPrincipalUuid: '',
      },
      rules: {
        contractPrincipalUuid: [
          {required: true, message: '请选择合同负责人', trigger: 'change'}
        ],
        invoicedPrincipalUuid: [
          {required: true, message: '请选择发票负责人', trigger: 'change'}
        ],
      },
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form = JSON.parse(JSON.stringify(newVal))
        }
      },
      immediate:true
    }
  },
  mounted() {
    this.getPersonOption()
  },
  methods:{
    getPersonOption() {
      let data = {
        deptTypes: ["BUSINESS_COMMERCIAL"]
      }
      getPersonByType('', data).then(res => {
        if(res.code === 200) {
          this.personOption = res.data
        }
      })
    },
    handle() {
      this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          bindCharge(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$emit('submit','confirm')
              this.$messageUi.success('提交成功')
            }
          }).catch(err => {
            this.loading = false
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    },
    cancel(){
      this.$emit('submit','cancel')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

.upload-demo {
  margin-top: 20px;
}

.upload-container {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.titlehand {
  display: flex;
  justify-content: center;
}
</style>